import axios from 'axios';
import env from 'react-dotenv';
import dotenv from 'dotenv';

dotenv.config();

/**
 * base url of stations API
 */
const STATION_LIST_URL = env[process.env.REACT_APP_HOST_TYPE];
/**
 * Axios instance for dealing with stations API
 */
const HttpListClient = axios.create({
  baseURL: STATION_LIST_URL,
  timeout: 5000,
});

export { HttpListClient, STATION_LIST_URL };
